"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.avatar.setup.title': 'Configura il Tuo Avatar',
    'onboarding.avatar.config.title': 'Configurazione Avatar',
    'onboarding.avatar.name.label': 'Nome Avatar',
    'onboarding.avatar.name.placeholder': 'Inserisci nome avatar',
    'onboarding.avatar.name.required': '*',
    'onboarding.avatar.age.label': 'Età Avatar',
    'onboarding.avatar.age.placeholder': 'Inserisci età avatar',
    'onboarding.avatar.gender.label': 'Genere Avatar',
    'onboarding.avatar.gender.placeholder': '-- Seleziona Genere --',
    'onboarding.avatar.gender.male': 'Maschile',
    'onboarding.avatar.gender.female': 'Femminile',
    'onboarding.avatar.voice.label': 'Voce Avatar',
    'onboarding.avatar.voice.placeholder': '-- Seleziona Voce --',
    'onboarding.avatar.voice.loading': 'Caricamento voci...',
    'onboarding.avatar.voice.select_gender_first': 'Per favore seleziona prima il genere',
    'onboarding.avatar.voice.male': 'Maschile',
    'onboarding.avatar.voice.female': 'Femminile',
    'onboarding.avatar.description.label': 'Descrizione Avatar',
    'onboarding.avatar.description.placeholder': 'Descrivi la personalità e le caratteristiche del tuo avatar',
    'onboarding.avatar.image.label': 'Immagine Avatar',
    'onboarding.avatar.image.placeholder': 'Carica immagine avatar...',
    'onboarding.avatar.name': 'Nome Avatar',
};
